import { PublicKey } from '@solana/web3.js';

export const ECOSYSTEM_PAGE = new PublicKey(
  'H3e67AJqEx3yiWcSdP7g6qVkrAeCrpJSkQtxAKy7QYGK',
);

export const STEALTH_HUBS = new Set([
  'DA5G7QQbFioZ6K33wQcH8fVdgFcnaDjLD7DLQkapZg5X',
]);
